// « Nouvel éditeur mobile » — the CONTEXT DOCK.
//
// On phones the selection's actions (the photo pill, the crop pill, the cover
// text bar…) used to float over the album, next to what was selected. In the
// new layout they are docked at the bottom of the screen instead, in the
// same strip the tab bar lives in — the album never has a control drawn on it.
//
// The EXISTING bars are not rewritten: each one asks `useMobileDock()` and,
// when the dock exists, portals its very same buttons into it rather than
// positioning itself over the page. No dock (desktop, tablet, switch off) =
// exactly the old behaviour.
import { createContext, useContext } from 'react';

export const MobileDockContext = createContext<HTMLElement | null>(null);

/** The dock element when the new phone layout is on, else null. */
export function useMobileDock(): HTMLElement | null {
  return useContext(MobileDockContext);
}

/** Style for a bar living in the dock (no fixed positioning, no shadow). */
export const DOCKED_BAR_STYLE: React.CSSProperties = {
  position: 'relative',
  pointerEvents: 'auto',
};
